import DatasetsIndex from './DatasetsIndex';
import DatasetShow from './DatasetShow';

const DatasetDefinitionScreens = {
  DatasetsIndex,
  DatasetShow,
};

export default DatasetDefinitionScreens;
